import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getActividadesAplicacionPlantelService,
  getActividadAplicacionPlantelByIdService,
  updateActividadAplicacionPlantelService,
  toggleActividadAplicacionPlantelActiveService,
  createMultiplesActividadesAplicacionPlantelService,
} from "../../../../services/seleccionAplicacion/actividades-aplicacion-plantel/ActividadesAplicacionPlantel.service";

export const getActividadesAplicacionPlantelThunk = createAsyncThunk(
  "actividadesAplicacionPlantel/getAll",
  async (
    { plantelId, page = 1, search = "", talento = "" } = {},
    { rejectWithValue },
  ) => {
    try {
      return await getActividadesAplicacionPlantelService(
        plantelId,
        page,
        search,
        talento,
      );
    } catch (error) {
      if (error.response?.status === 404)
        return rejectWithValue("Página no válida");
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener actividades",
      );
    }
  },
);

export const getActividadAplicacionPlantelByIdThunk = createAsyncThunk(
  "actividadesAplicacionPlantel/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getActividadAplicacionPlantelByIdService(id);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al obtener actividad",
      );
    }
  },
);

export const updateActividadAplicacionPlantelThunk = createAsyncThunk(
  "actividadesAplicacionPlantel/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateActividadAplicacionPlantelService(id, payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al actualizar actividad",
      );
    }
  },
);

export const toggleActividadAplicacionPlantelActiveThunk = createAsyncThunk(
  "actividadesAplicacionPlantel/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleActividadAplicacionPlantelActiveService(id);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Error al cambiar estado",
      );
    }
  },
);

export const createMultiplesActividadesAplicacionPlantelThunk =
  createAsyncThunk(
    "actividadesAplicacionPlantel/createMultiples",
    async (payload, { rejectWithValue }) => {
      try {
        return await createMultiplesActividadesAplicacionPlantelService(
          payload,
        );
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.detail ||
            error.response?.data?.message ||
            "Error al crear actividades",
        );
      }
    },
  );
